import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { cachedObservable } from '../core/cached-observable';

@Injectable({
  providedIn: 'root'
})
export class SourceService {
  constructor(private http: HttpClient) { }

  headers = new HttpHeaders({
    'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre- check= 0',
    'Pragma': 'no-cache',
    'Expires': '0'
  });
  getall(nocache = false) {
    return this.http.get<any[]>(environment.app.apiUrl + `source/all`, { headers: nocache ? this.headers : undefined }).toPromise();
  }

  sources$ = cachedObservable<any[]>(this.http, 'source-all', 'contacts',
    environment.app.apiUrl + `source/all`
  );

  save(source: any) {
    return this.http.post(environment.app.apiUrl + `source/save`, source).toPromise();
  }

  add(source: any) {
    return this.http.post(environment.app.apiUrl + `source/add`, source).toPromise();
  }
}
